import React from 'react';
import VideoTile from './VideoTile';
import { useRoom } from '../context/RoomContext';
import './VideoGrid.css';

const VideoGrid = () => {
  const { 
    localStream,
    remoteStreams,
    participants,
    userName,
    socketId, // ID du socket local
    screenSharingUserId, // ID de l'utilisateur qui partage son écran
  } = useRoom();

  const getParticipantInfo = (odId) => {
    return participants.find((p) => p.id === odId) || {};
  };

  // Filtrer les streams distants pour exclure l'utilisateur local
  // (il ne doit pas voir son propre flux en double)
  const remoteStreamEntries = Array.from(remoteStreams.entries()).filter(
    ([peerId]) => peerId !== socketId
  );

  const totalParticipants = remoteStreamEntries.length + 1; // +1 for local

  // Calculer la disposition grid dynamiquement selon le nombre de participants
  const getGridStyle = () => {
    // auto-fit avec minmax pour adaptation automatique
    // Taille minimale des tuiles : 400px pour 1-2 pers, 220px pour 3+
    const minTileWidth = totalParticipants <= 2 ? 400 : 220;
    
    return {
      display: 'grid',
      gap: '12px',
      padding: '12px',
      height: '100%',
      width: '100%',
      gridTemplateColumns: `repeat(auto-fit, minmax(${minTileWidth}px, 1fr))`,
      gridAutoRows: 'minmax(120px, 1fr)',
      alignContent: 'start',
    };
  };

  return (
    <div className="video-grid" style={getGridStyle()}>
      {/* Local video */}
      <VideoTile
        stream={localStream}
        name={userName}
        isMuted={false} // local mute is handled separately
        isVideoOff={false}
        isLocal={true}
        isLarge={totalParticipants <= 2}
        // Pas de bouton plein écran sur la vidéo locale
      />

      {/* Remote videos - exclure l'utilisateur local */}
      {remoteStreamEntries.map(([peerId, stream]) => {
        const participant = getParticipantInfo(peerId);
        return (
          <VideoTile
            key={peerId}
            stream={stream}
            name={participant.name || 'Inconnu'}
            isMuted={participant.isMuted}
            isVideoOff={participant.isVideoOff}
            isLocal={false}
            isLarge={totalParticipants <= 2}
            isScreenSharing={peerId === screenSharingUserId}
          />
        );
      })}
    </div>
  );
};

export default VideoGrid;
